/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
type SbRespTradeFreeShippingPromoTile_itemSearch$ref = any;
type SbSharedPriceTile_itemSearch$ref = any;
export type SbRespPriceTiles_itemSearch$ref = any;
export type SbRespPriceTiles_itemSearch = {
    readonly displayUriRef: string | null;
    readonly priceTiles: ReadonlyArray<{
        readonly currency: string | null;
        readonly displayName: string | null;
        readonly image: string | null;
        readonly url: string | null;
    } | null> | null;
    readonly " $fragmentRefs": SbSharedPriceTile_itemSearch$ref & SbRespTradeFreeShippingPromoTile_itemSearch$ref;
    readonly " $refType": SbRespPriceTiles_itemSearch$ref;
};



const node: ReaderFragment = ({
    "kind": "Fragment",
    "name": "SbRespPriceTiles_itemSearch",
    "type": "ItemSearchQueryConnection",
    "metadata": null,
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "isTrade",
            "type": "Boolean"
        }
    ],
    "selections": [
        {
            "kind": "ScalarField",
            "alias": null,
            "name": "displayUriRef",
            "args": null,
            "storageKey": null
        },
        {
            "kind": "LinkedField",
            "alias": null,
            "name": "priceTiles",
            "storageKey": null,
            "args": [
                {
                    "kind": "Variable",
                    "name": "isTrade",
                    "variableName": "isTrade"
                }
            ],
            "concreteType": "SearchBrowsePriceTile",
            "plural": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "currency",
                    "args": null,
                    "storageKey": null
                },
                {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "displayName",
                    "args": null,
                    "storageKey": null
                },
                {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "image",
                    "args": null,
                    "storageKey": null
                },
                {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "url",
                    "args": null,
                    "storageKey": null
                }
            ]
        },
        {
            "kind": "FragmentSpread",
            "name": "SbSharedPriceTile_itemSearch",
            "args": null
        },
        {
            "kind": "FragmentSpread",
            "name": "SbRespTradeFreeShippingPromoTile_itemSearch",
            "args": null
        }
    ]
} as any);
(node as any).hash = '75c73df7d2d5ac0e8d987716a7fa52fe';
export default node;
